// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30M0B","tabsBox":"styles_tabsBox__3aSEf","createButton":"styles_createButton__1_-Hb"};